import { AUSTRALIA_PRODUCTION_SITE_URL } from './storefrontEnvironment.js'

const DEVELOPMENT_AUSTRALIA_SHOP_IDS = ['920703319745835031', '920703319745835029']
const SHOP_ID_FIELDS = new Set(['dealerShopId', 'shopId', 'shopid'])

function isAustraliaProductionSite(currentServer = '') {
  try {
    const server = String(currentServer || '').trim()
    const hostname = new URL(/^https?:\/\//i.test(server) ? server : `https://${server}`).hostname
    return hostname === new URL(AUSTRALIA_PRODUCTION_SITE_URL).hostname
  } catch {
    return false
  }
}

export function resolveStorefrontShopId(value, currentServer) {
  const shopId = String(value || '').trim()
  if (!isAustraliaProductionSite(currentServer)) return shopId
  // A local AU preview may use another shop without changing the live domain's
  // default. Explicit IDs belonging to other shops remain intact.
  if (process.env.NODE_ENV === 'development') {
    try {
      const localShopId = String(useRuntimeConfig().public.devAustraliaShopId || '').trim()
      if (localShopId && ['', ...DEVELOPMENT_AUSTRALIA_SHOP_IDS].includes(shopId)) return localShopId
    } catch { /* No runtime configuration outside Nuxt. */ }
  }
  // Live storefronts use the shop returned by domain matching. The approved
  // FlyPay callback host does not make Lynicebuy share Drawlark's shop.
  return shopId
}

// Only local development may override shop identifiers; production data is kept.
export function normalizeStorefrontShopData(value, currentServer) {
  if (process.env.NODE_ENV !== 'development' || !isAustraliaProductionSite(currentServer)) return value

  const normalize = (record) => {
    if (Array.isArray(record)) return record.map(normalize)
    if (!record || Object.prototype.toString.call(record) !== '[object Object]') return record
    const entries = Object.entries(record).map(([key, item]) => {
      if (SHOP_ID_FIELDS.has(key) && item != null && String(item).trim()) {
        return [key, resolveStorefrontShopId(item, currentServer)]
      }
      if (key === 'configData' && typeof item === 'string') {
        try {
          return [key, JSON.stringify(normalize(JSON.parse(item)))]
        } catch {
          return [key, item]
        }
      }
      return [key, normalize(item)]
    })
    return Object.fromEntries(entries)
  }

  return normalize(value)
}

export function normalizeStorefrontShopUrl(url, currentServer) {
  if (process.env.NODE_ENV !== 'development' || !isAustraliaProductionSite(currentServer) || !String(url).includes('?')) return url
  const queryStart = url.indexOf('?')
  const query = new URLSearchParams(url.slice(queryStart + 1))
  let changed = false
  for (const key of SHOP_ID_FIELDS) {
    const value = query.get(key)
    const resolved = value == null ? value : resolveStorefrontShopId(value, currentServer)
    if (resolved !== value) {
      query.set(key, resolved)
      changed = true
    }
  }
  return changed ? `${url.slice(0, queryStart)}?${query}` : url
}
